<template>
  <b-container fluid>
    <backlink />
    <h1>Facturation manuelle</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="group_slug" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge
            v-if="data.value.includes('outillage')"
            variant="outillage"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge
            v-if="data.value.includes('instruments')"
            variant="instruments"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('instruments').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge
            v-if="data.value.includes('service_et_logistique')"
            variant="service_et_logistique"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "ManualBillingList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
  computed: {
    options: function () {
      return {
        bill_type_slug_options: this.$store.getters["manual_billing/getTypes"],
        agency_options: this.$store.getters["agency/getAll"].selectOptions("id", [
          "internal_number",
          " - ",
          "name",
        ]),
        group_slug_options: this.$store.getters["renting_preparation/getGroups"],
        from_mcs_options: [
          { value: null, text: "Toutes" },
          { value: '1', text: "Reprise MCS" },
          { value: '0', text: "Axiloc" },
        ],
      };
    },
  },
  created() {
    this.$store.dispatch("agency/getAllForSelect");
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque 
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "manualbilling", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              billTypeSlug: ctx.extended_filters_model.bill_type_slug,
              agency: ctx.extended_filters_model.agency,
              groupSlug: ctx.extended_filters_model.group_slug,
              from_mcs: ctx.extended_filters_model.from_mcs,
              startBillingDate: ctx.extended_filters_model.billing_date.start
                ? self.$moment(ctx.extended_filters_model.billing_date.start).format("YYYY-MM-DD")
                : null,
              endBillingDate: ctx.extended_filters_model.billing_date.end
                ? self.$moment(ctx.extended_filters_model.billing_date.end).format("YYYY-MM-DD")
                : null,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.manualBillings || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/ManualBilling/ManualBillingList.vue